import React, { Component } from "react";
import {
  fontColor,
  primaryColor,
  textBlack,
  webFont
} from "../../config/theme";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  Hidden,
  InputAdornment,
  InputLabel,
  Typography
} from "@material-ui/core";
import Input from "@material-ui/core/Input";
import { compose, graphql } from "react-apollo";
import { UPDATE } from "../../graphql/mutations/user";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import { connect } from "react-redux";
import style from "../Login/style";
import ResetPasswordDrawer from "./ResetPasswordDrawer";
import { passwordRegex } from '../../config/constants';
import { NotificationManager } from "react-notifications";
import {logoutUser, setForceChangePassword} from "../../redux/auth";

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: ""
      },
      errData: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: ""
      },
      errors: false,
      loading: false,
      openPasswordDrawer: true,
      showPassword: false,
      showResetPassword: false,
      forceChangePassword: window.localStorage.getItem('ccZestyForceChangPassword'),
    };
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  toggleShowResetPassword = () => {
    this.setState({ showResetPassword: !this.state.showResetPassword });
  };

  handleChange = (name, e) => {
    let { errData, formData } = this.state;

    const re = /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,}$/;
    this.setState({ errors: true });
    switch (name) {
      case "oldPassword":
        formData.oldPassword = e.target.value;
        if (e.target.value == "") {
          errData.oldPassword = "Please enter a valid Old password ";
        } else {
          errData.oldPassword = "";
        }

        break;
      case "newPassword":
        formData.newPassword = e.target.value;
        if (e.target.value == "") {
          errData.newPassword = "Please enter a valid new password ";
        } else if (!re.test(e.target.value)) {
          errData.newPassword =
            "Password must contain at least 8 characters, one number, one letter";
        } else {
          errData.newPassword = "";
        }
        break;
      case "repeatPassword":
        formData.repeatPassword = e.target.value;
        if (e.target.value == "") {
          errData.repeatPassword = "Please enter same password ";
        } else if (formData.newPassword !== e.target.value) {
          errData.repeatPassword = "Please enter same password ";
        } else {
          errData.repeatPassword = "";
        }
    }
    this.setState({ formData: { ...this.state.formData, ...formData } });
  };

  validateDetails() {
    let stateErrors = this.state.errData;
    let validated = true;
    for (let key in stateErrors) {
      if (stateErrors[key]) {
        validated = false;
      }
    }

    return validated;
  }

  submitDetail = event => {
    event.preventDefault();
    if (this.state.errors) {
      const { updateUser } = this.props;
      let formData = event.target.elements;
      let payload = {
        id: this.props.userId,
        pwd: formData.newPassword.value
      };
      if (this.validateDetails()) {
        let formData = event.target.elements;
        const { newPassword, repeatPassword } = formData;
        if (newPassword.value !== repeatPassword.value) {
          return NotificationManager.error('New and Repeat passwords do not match', 'Password Change');
        }
        updateUser({
          variables: { user: payload }
        })
          .then(res => {
            NotificationManager.info(
              "Password Updated Successfully.",
              "Password Change"
            );
            this.setState({
              openPasswordDrawer: false
            });
            this.props.dispatch(setForceChangePassword(false));
            this.props.dispatch(logoutUser());
            this.props.history.push("/");
          })
          .catch(err => {
            const error = JSON.parse(JSON.stringify(err));
            NotificationManager.error(
              error.graphQLErrors[0].message,
              "Password Change"
            );
          });
      }
    }
  };

  render() {
    return (
      <Grid container>
        <Grid container justify="flex-end" />
        <Grid item xs={12} style={{ margin: "10px 10px" }}>
          <h4 style={styles.headerText}>Change password</h4>
          <p style={styles.subHeaderText}>Use at least 8 characters with letters and numbers</p>

          {this.state.forceChangePassword && this.state.forceChangePassword != 'false' && <p style={styles.subHeaderTextNotif}>
            For your account security, please change your password.
          </p>}
        </Grid>

        <Grid container>
          <form
            action="#!"
            method="post"
            style={{ width: "100%" }}
            onSubmit={e => this.submitDetail(e)}
          >
            <Grid item xs={12} style={styles.inputCtrl}>
              <FormControl fullWidth={true}>
                <InputLabel style={styles.ftText}>New password</InputLabel>
                <br />
                <Input
                  name={"newPassword"}
                  placeholder={""}
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.formData.newPassword}
                  onChange={e => {
                    this.handleChange("newPassword", e);
                  }}
                  style={styles.inputText}
                  endAdornment={
                    <InputAdornment position="end">
                      <p
                        data-test-id={"showpwd-id"}
                        aria-label="Toggle Password Visibility"
                        onClick={this.toggleShowPassword}
                        style={styles.showButton}
                      >
                        Show
                      </p>
                    </InputAdornment>
                  }
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errData.newPassword}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} style={styles.inputCtrl}>
              <FormControl fullWidth={true}>
                <InputLabel style={styles.ftText}>
                  Retype new password
                </InputLabel>
                <br />
                <Input
                  name={"repeatPassword"}
                  placeholder={""}
                  type={this.state.showResetPassword ? "text" : "password"}
                  value={this.state.formData.repeatPassword}
                  onChange={e => {
                    this.handleChange("repeatPassword", e);
                  }}
                  style={styles.inputText}
                />
                <FormHelperText id="component-error-text" style={styles.error}>
                  {this.state.errData.repeatPassword}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ ...style.inputCtrl, ...style.topSpace }}
            >
              <Button
              data-test-id={"chgpwdsubmit"}

                type="submit"
                variant="contained"
                fullWidth={true}
                color="primary"
                style={style.btnLogin}
              >
                Submit
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef
  };
};
const ResetPasswordWithData = compose(
  graphql(UPDATE, { name: "updateUser" }),
  graphql(UPDATE_CHEF, { name: "updateChef" })
)(ResetPassword);
const UserUpdatePassword = connect(mapSateToProps)(ResetPasswordWithData);

export default UserUpdatePassword;
const styles = {
  headerText: {
    fontSize: 26,
    fontWeight: 500,
    textAlign: "left",
    margin: '30px 0 0',
    paddingBottom: 10,
    fontFamily: webFont,
    color: '#000'
  },
  showButton: {
    fontSize: 14,
    color: '#000',
    fontWeight: 500,
    position: 'absolute',
    top: '-35px',
    right: 0,
    cursor: 'pointer',
    margin: 0,
  },
  ftText: {
    fontFamily: webFont,
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
    top: '-30px',
    transform: 'none !important',
  },
  subHeaderText: {
    fontSize: 15,
    textAlign: "left",
    margin: 0,
    paddingBottom: 10,
    fontFamily: webFont,
    fontWeight: "normal"
  },
  subHeaderTextNotif: {
    fontSize: 14,
    textAlign: "left",
    margin: 0,
    paddingBottom: 10,
    fontFamily: webFont,
    fontWeight: "normal",
    color: '#ff8000',
    marginTop: 15,
    marginBottom: 15,
  },
  inputButtonContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    width: "100%",
    height: "62%"
  },
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "200px",
    color: "white",
    height: 40,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "500"
  },
  inputCtrl: {
    width: "100%",
    padding: "7px 15px",
    marginTop: 24,
  },
  topSpace: {
    marginTop: "30px"
  },
  error: {
    color: "red"
  },
  setColor: {
    color: primaryColor
  },
  msg: {
    fontWeight: 500,
    color: textBlack,
    textTransform: "none",
    fontFamily: webFont
  },
  setFont: {
    fontFamily: webFont
  },
  btnLogin: {
    textTransform: "none",
    fontFamily: webFont,
    fontWeight: 500,
    borderRadius: "35px"
  },
  errGrid: {
    width: "100%",
    alignItems: "center",
    justify: "center",
    textAlign: "center",
    marginBottom: "25px",
    backgroundColor: "red"
  },
  errGridText: {
    font: webFont,
    color: fontColor
  },
  closeIcon: {
    margin: "10px 0px",
    fontFamily: webFont,
    fontSize: "32"
  }
};
